// utils
import axios from '../../utils/axios';

const createPartner = async (data) => {
  try {
    // const userId = localStorage.getItem('_id');
    const response = await axios({
      method: 'post',
      url: `/partners`,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data,
    });
    const res = await response.data;
    return res;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};

export { createPartner };
